import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { pbdkf2 } from "../../Utils/OstreonEncryption";
import styles from "./styles/Login.module.css"
import { useNavigate } from "react-router-dom";
import config from '../../config';
import { useEmployeeAuth } from "../Administrator/AdminProvider";
import { stepButtonClasses } from "@mui/material";
const base_url=config.base_url
// import { getSHA256 } from "../../Utils/getSHA256";
export function EmployeeLogin(){
    const [username, setUsername]=useState('')
    const [password, setPassword]=useState('')
    const [loginError, setLoginError]=useState(null)
    const [disableButton, setButtonDisabled] = useState(false)
    const auth = useEmployeeAuth()
    const navigate = useNavigate();
    useEffect(()=>{
        console.log(auth)
        if (auth.isAuth) navigate('/admin/customers')
    }, [auth])
    useEffect(() => {
        const script = document.createElement("script")
        script.src = "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu"
        document.body.appendChild(script)
      }, [])
    const showError = (error)=>{
        setLoginError(error)
        setTimeout(()=>{
            setLoginError(null)
        }, 3000);
    }
    const handleLogin = async(token)=>{
        
        let credentials = {}
        credentials.username=username
        credentials.password=password
        const [pbdkf2hash, ] = await pbdkf2(password, 'OSTREON', 100000, 32*8)
        fetch(base_url+'admin/login', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials':'include'
            },
            body: `username=${username}&password=${pbdkf2hash}&token=${token}`,
            credentials:'include'
        }).then((res)=>{
            if (res.status!==200) throw new Error()
            else return res.json()
        }).then((data)=>{
            if (data.error) showError(data.error)
            else{
                auth.setHasPWD(true)
                navigate('/admin/login/OTP', {replace:true});
            }
        }).catch((err)=>{
            console.log(err)
            showError('An error occurred')
        }).finally(()=>setButtonDisabled(false))
    }
    const submitCaptcha = (e)=>{
        e.preventDefault()
        window.grecaptcha.ready(() => {
            setButtonDisabled(true)
            window.grecaptcha.execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu").then(token => {
                if (!username || !password) return showError('Please provided username and password')
                handleLogin(token)
            }).catch(()=>{
                setButtonDisabled(false)
            })
            });
    }
    const handleEnter = (e) =>{
        if (e.key==="Enter"){
            submitCaptcha(e)
        }
    }
    return(   
        <div className={styles.main_div}>
            <div className={styles.title}>Employee Login</div>
            <div className={styles.main_box}>
                <div className={styles.top}>
                    <div className={styles.input_text}>Email Address</div>
                    <input autoFocus onKeyDown={handleEnter} className={styles.input} value={username} onChange={(e)=>{setUsername(e.target.value.toLowerCase())}} placeholder="Email Address"></input>
                    <div className={styles.input_text}>Password</div>
                    <input onKeyDown={handleEnter} type="password" value={password} onChange={(e)=>{setPassword(e.target.value)}} className={styles.input} placeholder="Password" />
                    <button disabled={disableButton} onClick={(e)=>submitCaptcha(e)} className={styles.login_button}>Login</button>
                    {loginError?<div className={styles.login_error}>{loginError}</div>:null}
                    {/* <div onClick={()=>navigate('/login/recoverykey', {replace:false})} className={styles.forgot_your_password}>Forgot your password?</div>
                    <div className={styles.login_rect}></div> */}
                </div>
                {/* <div className={styles.center}>
                    <div className={styles.not_a_customer}>Not Yet a Customer?</div>
                    <div onClick={()=>navigate('/register', {replace:false})} className={styles.create_new_user}>Create a New User!</div>
                    <div className={styles.not_a_customer}>It's free!</div>
                    <div className={styles.login_rect}></div>
                </div>
                <div className={styles.bottom}>
                    <div className={styles.not_a_customer}>Are you a beneficiary?</div>
                    <div onClick={()=>navigate('/beneficiary/login', {replace:false})} className={styles.login_beneficiary}>Login As Beneficiary</div>
                </div> */}
            </div>
        </div>
    )   
}